import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

interface BaseItemContrastOptionProps {
  contrast: number;
  updateContrast(brightness: number, undoable?: boolean): void;
}

export function BaseItemContrastOption({...props}: BaseItemContrastOptionProps): ReactElement<any> {
  const onChangeHandler = (updatedValue: number): void => {
    props.updateContrast(updatedValue, false);
  };

  const onChangeEndedHandler = (updatedValue: number): void => {
    props.updateContrast(updatedValue);
  };
  return (
    <ContextualMenuSliderOptions
      id="item-contrast-option"
      value={props.contrast}
      label={window.i18next.t('pmwjs_contrast')}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEndedHandler}
      range={{min: -1, max: 1}}
      transformDisplay={{min: 0, max: 100}}
    />
  );
}
